import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {getUserId} from '@/services/internal/user/getUserId';
import {USER_ID_HEADER} from '@/utils/constant';

type Season = {
  created_at: string;
  deleted_at: string | null;
  paused_at: string | null;
  synced_at: string | null;
  start_time: string;
  end_time: string;
  updated_at: string;
  season_name: string;
  description: string;
  id: string;
  color: string;
  game_id: string;
  season_index: number;
  is_active: boolean;
  season_params: Array<unknown>;
};

type GetProgressionSeasonsResponse = {
  count: number;
  items: Array<Season>;
};

export async function getCurrentSeason(): Promise<GetProgressionSeasonsResponse> {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();

  try {
    const response = await fetch(`/apigw/v1/progression-seasons?min-index=0&max-index=0`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      throw new Error('Failed to fetch current season');
    }

    return await response.json();
  } catch (e) {
    console.error('Error fetching current season:', e);
    throw e;
  }
}

export async function getNextSeasons(count: number): Promise<GetProgressionSeasonsResponse> {
  if (count <= 0) {
    throw new Error('Invalid count for seasons request. Count must be >= 1.');
  }

  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();

  try {
    const response = await fetch(`/apigw/v1/progression-seasons?min-index=1&max-index=${count}`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      throw new Error('Failed to fetch next seasons');
    }

    return await response.json();
  } catch (e) {
    console.error('Error fetching next seasons:', e);
    throw e;
  }
}

export async function getPreviousSeasons(count: number): Promise<GetProgressionSeasonsResponse> {
  if (count <= 0) {
    throw new Error('Invalid count for seasons request. Count must be >= 1.');
  }

  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();

  try {
    const response = await fetch(`/apigw/v1/progression-seasons?min-index=${-count}&max-index=-1`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      throw new Error('Failed to fetch previous seasons');
    }

    return await response.json();
  } catch (e) {
    console.error('Error fetching previous seasons:', e);
    throw e;
  }
}

// @GET("/v1/progression-seasons")
// /v1/progression-seasons?min-index=0&max-index=0 current season
